'use client';

import * as React from 'react';
import { SimpleListing } from '@th/shared/src/types/SimpleListing';
import { Agent } from '@th/shared/src/types/Agent';
import PropertyInquiryForm from './PropertyInquiryForm';

type Props = {
  listing: SimpleListing;
  agent: Agent;
};

const SCHEDULE_VIEWING_TITLE = 'See the property';
const SCHEDULE_VIEWING_SUBTITLE = 'Tour with an agent';
const REQUEST_INFO_TITLE = 'Get more info';
const REQUEST_INFO_SUBTITLE = 'We’ll send you more details';

export default function PropertyInquiryCard({ listing, agent }: Props) {
  return (
    <div className="flex flex-col bg-background p-6 border rounded-lg gap-y-2 shadow-2xl">
      <h3 className="text-xl">
        {listing.isActive() ? SCHEDULE_VIEWING_TITLE : REQUEST_INFO_TITLE}
      </h3>
      <p className="text-secondaryText">
        {listing.isActive() ? SCHEDULE_VIEWING_SUBTITLE : REQUEST_INFO_SUBTITLE}
      </p>
      <PropertyInquiryForm listing={listing} agent={agent} />
    </div>
  );
}
